<div class="jbm-properties-list {{className}}">
    <div *ngFor="let property of properties" class="item {{property.className}}">
        <label class="label">{{property.label}}:</label>
        <label class="value">{{property.value}}</label>
    </div>
</div>
